import * as React from "react";
import {createElement as h} from "react";
import {cx} from "emotion";

import "./listing-records-desktop.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";
import {isIe}  from "@Common/ui-components/debug/is-ie-edge-or-firefox";

import {GridViewCard} from "../card/grid-view-card";
import {ListViewCard} from "../card/list-view-card";

export const ListingRecordsDesktop = ({viewType, listings, onCreateMarketingMaterials}) => cs(
    ({}) => (
        <div className="listing-records-desktop-2it">

            <div className={cx("list", viewType + "-view", {ie: isIe()})}>
                {listings.map((record, i) => cs(
                    keyed(i),
                    ({}) => (
                        h(viewType === "list" ? ListViewCard : GridViewCard, {
                            record,
                            onCreateMarketingMaterials,
                        })
                    ),
                ))}
            </div>
        </div>
    ),
);

